<template>
  <div class="dialog-add-account" v-loading="loading">
    <div class="dialog-add-account__title" v-html="$t('documents.title')" />
    <div class="dialog-add-account__desc">
      {{ $t('documents.description') }}
    </div>
    <div class="dialog-add-account-document__form">
      <Selector
        ref="file"
        class="application__selector application__input"
        :title="$t('documents.file_type')"
        :options="files"
        :select-fitrst-item="false"
        :origin="'documents'"
        :error="errors.file_type"
        @handleChange="
          (val) => {
            form.file_type = val;
            form.status = '';
          }
        "
      />
      <FormInput
        v-if="form.file_type === 'invoice'"
        :label="$t('documents.invoice_amount')"
        :full="form.invoice_amount"
        :error="errors.invoice_amount"
      >
        <input v-model="form.invoice_amount" type="text" pattern="\d+" required />
      </FormInput>

      <Selector
        v-if="isInvoice"
        ref="currency"
        class="application__selector application__input"
        :title="$t('documents.invoice_currency_selector')"
        :options="currency"
        :select-fitrst-item="false"
        @handleChange="(val) => (form.invoice_currency = val)"
      />
      <Selector
        v-show="form.file_type === 'agreement' || form.file_type === 'terms' || form.file_type === 'act'"
        ref="status"
        class="application__selector application__input"
        :title="$t('documents.status')"
        :options="statuses"
        :select-fitrst-item="false"
        :fileType="form.file_type"
        @handleChange="(val) => (form.status = val)"
      />
      <Selector
        v-show="isInvoice"
        ref="statusInvoice"
        class="application__selector application__input"
        :title="$t('documents.status')"
        :options="invoices"
        :select-fitrst-item="false"
        :fileType="form.file_type"
        @handleChange="(val) => (form.status = val)"
      />

      <FormInput label="Document number" :full="form.number" :error="errors.number">
        <input v-model="form.number" type="text" required />
      </FormInput>

      <SingleDatePicker
        class="fw"
        v-show="isInvoice"
        :title="'Date invoice'"
        style="--datepicker-width: 100%"
        :value="form.file_date"
        @changeDates="changeDates"
        appendToBody
        :error="errors.file_date"
      />

      <div class="fw flex-row ai-center gap-1">
        <input type="checkbox" value="all" required v-model="form.status_agreement" />
        <span>Is main document</span>
      </div>
      <div class="form-input">
        <!-- <div v-if="filesArr && Object.keys(filesArr).length" class="document__upload-files">
                    <div v-for="(item, idx) in filesArr" :key="idx" class="document__upload-files-item">
                    <span v-if="item.name" v-text="item.name" />
                    <button class="document__upload-files-delete" @click="deleteFile(item.id)">
                        <img src="@/assets/icons/icon-close.svg" alt="">
                    </button>
                    </div>
                </div> -->
        <div v-if="filesArr && Object.keys(filesArr).length" class="document__upload-files">
          <div class="document__upload-files-item">
            <span v-if="filesArr.name" v-text="filesArr.name" />
            <button class="document__upload-files-delete" @click="deleteFile(filesArr.id)">
              <img src="@/assets/icons/icon-close.svg" alt="Close icon" />
            </button>
          </div>
        </div>
        <label class="document__upload">
          <div class="button button--empty">{{ $t('documents.attach_file') }}</div>
          <input :disabled="Object.keys(filesArr).length > 0" id="files" type="file" @change="checkFile" />
        </label>
      </div>

      <ButtonElement
        :text="$t('button_props.add_document')"
        :disabled="isButtonDisabled"
        @click-button="addDocument"
        class="application__send-button"
      />
    </div>
  </div>
</template>

<script>
import formValidate from '../../mixin/formValidate';
import getCurrentDate from '../../mixin/getCurrentDate';
import ButtonElement from '../../components/elements/ButtonElement';
//   import DateRangePicker from 'vue2-daterange-picker'
import Selector from '@/components/sort/Selector';
import { MONTHES_SHORT } from '../../constants';
import FormInput from '../elements/FormInput.vue';
import SingleDatePicker from '../sort/SingleDatePicker.vue';
import { useDocuments, useForm } from '../../mixin';
// import axios from 'axios'

// const apiUrl = process.env.VUE_APP_API_URL

export default {
  name: 'AddDocument',
  components: {
    //   DateRangePicker,
    ButtonElement,
    Selector,
    FormInput,
    SingleDatePicker,
  },
  mixins: [formValidate, getCurrentDate, useForm, useDocuments],
  data() {
    return {
      lang: this.$i18n._vm.locale,
      loading: false,
      isShow: false,
      respErr: '',
      dataError: false,
      currentDate: '',
      hours: new Date().getHours(),
      minutes: new Date().getMinutes(),
      seconds: new Date().getSeconds(),
      isDisabled: false,
      date: {
        startDate: new Date(),
        endDate: new Date(),
      },
      minDate: null,
      months: MONTHES_SHORT,
      activePeriod: 'day',
      form: {
        file_type: null,
        invoice_amount: '',
        invoice_currency: '',
        status: '',
        file_date: null,
        status_agreement: false,
        number: '',
      },
      filesArr: {},
      documentAdded: false,
    };
  },
  computed: {
    activeAccount() {
      return this.$store.state.Auth.activeAccount;
    },
    isInvoice() {
      return this.form.file_type === 'invoice';
    },
    start_at() {
      return this.fixDateFormatNumbers(this.date.startDate);
    },
    end_at() {
      return this.fixDateFormatNumbers(this.date.endDate);
    },
    files() {
      return this.$store.state.Documents.files;
    },
    statuses() {
      return this.$store.state.Documents.statuses;
    },
    currency() {
      return this.$store.state.Documents.currency;
    },
    invoices() {
      return this.$store.state.Documents.invoices;
    },
    fileType() {
      return this.form.file_type;
    },
    isButtonDisabled() {
      //:disabled="!form.file_type || !form.invoice_amount || !form.invoice_currency || !form.status || !filesArr.length"
      if (
        this.form.file_type === 'invoice' &&
        this.form.invoice_amount &&
        this.form.invoice_currency &&
        this.form.file_type &&
        this.form.status &&
        Object.keys(this.filesArr).length
      ) {
        return false;
      } else if (
        this.form.file_type !== 'invoice' &&
        this.form.file_type &&
        this.form.status &&
        Object.keys(this.filesArr).length
      ) {
        return false;
      }
      return true;
    },
  },

  created() {
    this.currentDate = this.fixDateFormatNumbers(new Date());
  },
  watch: {
    fileType(val) {
      if (val && val === 'Monthly report') {
        this.form.status = 'done';
      }
    },
  },
  methods: {
    closeModal() {
      this.$store.dispatch('Dialog/closeDialog');
    },
    changeDates(date) {
      this.form.file_date = Array.isArray(date) ? date[0] : date?.startDate ?? date;
    },
    cleanData() {
      if (this.$refs.file) {
        this.$refs.file.selectedValue = null;
      }
      if (this.$refs.status) {
        this.$refs.status.selectedValue = null;
      }
      if (this.$refs.statusInvoice) {
        this.$refs.statusInvoice.selectedValue = null;
      }
      if (this.$refs.currency) {
        this.$refs.currency.selectedValue = null;
      }
      for (let key in this.form) {
        this.form[key] = null;
      }
      this.filesArr = {};
      this.documentAdded = false;
    },
    fixDate(start, end) {
      if (start && end) {
        let str = '';
        const startDay = start.getDate();
        const endDay = end.getDate();

        const startMonth = start.getMonth();
        const endMonth = end.getMonth();
        const nameStartMonth = this.months.find((el) => el.id === startMonth).shortName;
        const nameEndMonth = this.months.find((el) => el.id === endMonth).shortName;

        if (startDay === endDay && startMonth === endMonth) {
          str = startDay + ' ' + nameStartMonth;
        } else if (startMonth === endMonth) {
          str = startDay + '-' + endDay + ' ' + nameStartMonth;
        } else {
          str = startDay + ' ' + nameStartMonth + ' - ' + endDay + ' ' + nameEndMonth;
        }

        return str;
      }
    },
    fixDateFormatNumbers(fixedDate) {
      if (fixedDate) {
        let date = new Date(fixedDate);
        let str = '';
        const startDay = String(date.getDate()).padStart(2, '0');
        const startMonth = String(date.getMonth() + 1).padStart(2, '0');
        const startYear = date.getFullYear();
        str = startYear + '-' + startMonth + '-' + startDay;
        return str;
      }
    },
    checkFile(e) {
      const files = e.target.files;
      if (files && files.length) {
        if (!this.documentAdded) {
          let reader = new FileReader();
          for (let i = 0; i < files.length; i++) {
            const el = files[i];
            const fileType = el.type;
            if (
              (fileType === 'application/pdf' ||
                fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') &&
              !this.documentAdded
            ) {
              reader.onload = (e) => {
                this.filesArr = { id: i + el.name, name: el.name, src: e.target.result, type: 'document', file: el };
              };
              reader.readAsDataURL(el);
              this.documentAdded = true;
            }
          }
        }
      }
    },
    deleteFile() {
      //add id as argument
      // this.filesArr = this.filesArr.filter(el => el.id !== id)
      this.filesArr = {};
      this.documentAdded = false;
    },
    addDocument() {
      if (this.form.file_type === 'invoice') {
        this.validateInvoice();
        if (!this.validateInvoice()) {
          return;
        }
      }
      const data = new FormData();
      for (let key in this.form) {
        if (this.form.file_type === 'invoice' || (key !== 'invoice_amount' && key !== 'invoice_currency')) {
          if (key === 'file_date') {
            const date = this.form[key];
            data.append('file_date', this.getCurrentDate(date));
          } else if (key === 'status_agreement') {
            data.append(key, this.form[key] ? 1 : 0);
          } else {
            data.append(key, this.form[key]);
          }
        }
      }
      data.append('business_account_id', this.activeAccount.id);
      data.append('stored_at', this.getCurrentDate());

      if (!this.isInvoice) {
        data.delete('file_date');
      }

      if (this.filesArr && Object.keys(this.filesArr).length) {
        data.append('file', this.filesArr.file);
        data.append('file_format', this.getFileExtension());
      }
      this.loading = true;
      this.$store
        .dispatch('Documents/addDocument', data)
        .then(() => {
          this.cleanData();
          this.$store.commit('Dialog/setData', { label: 'dialogVisible', data: null });
          this.$notify({
            message: this.$t('documents.success'),
            type: 'success',
          });
        })
        .catch(this.parseResponseError)
        .finally(() => {
          this.loading = false;
        });
    },
    getMIMEType() {
      if (this.filesArr && this.filesArr.file) {
        return this.filesArr.file.type;
      } else {
        return null;
      }
    },
    getFileExtension() {
      if (this.filesArr && this.filesArr.name) {
        return this.filesArr.name.split('.').pop();
      } else {
        return null;
      }
    },
    validateInvoiceNumber() {
      if (this.form.invoice_amount) {
        const regex = /^\d+$/;
        return regex.test(this.form.invoice_amount);
      }
    },
    validateInvoice() {
      if (this.form.invoice_amount) {
        if (!this.validateInvoiceNumber()) {
          this.errors.invoice_amount = this.$t('documents.invoice_amount_error');
          return false;
        }
        return true;
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/styles/helpers/variables';
@import '@/assets/styles/helpers/mixin';

//   @keyframes settingsRotate {
//     from {
//       transform: rotate(0);
//     }

//     to {
//       transform: rotate(360deg);
//     }
//   }

//   .fade-enter-active,
//   .fade-leave-active {
//     transition: opacity .3s;
//   }

//   .fade-enter,
//   .fade-leave-to {
//     opacity: 0;
//   }

//   .error {
//     color: red;
//   }

//   .save-users-data {
//     border: 1px solid #d8d9da;
//     font-weight: 700;
//     font-size: 1.6rem;
//     line-height: 1.9rem;
//     border-radius: 4px;
//     height: 3.5rem;
//     min-width: 12.5rem;
//     text-align: center;
//     padding-top: 7px;
//     margin-right: 1rem;
//   }

.dialog-add-account-document {
  &__data-picker {
    display: flex;
    justify-content: space-between;
  }

  &__data-title {
    font-weight: 700;
  }

  &__form {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    row-gap: 2rem;
    .selector__content {
      width: 100%;
    }
    .selector__title {
      font-size: 1.6rem;
      color: #878b93;
    }
    .form-input {
      margin: 0;
    }
    .document__upload {
      input {
        display: none;
      }

      &-files {
        width: 100%;
        margin-bottom: 10px;

        &-item {
          padding: 1.4rem 0;
          border-bottom: 1px solid $gray7;
          display: flex;
          align-items: center;
          justify-content: space-between;

          &:last-child {
            border: none;
          }
        }

        &-delete {
          background: none;
          border: none;
        }
      }

      .button {
        font-weight: 400;
        color: var(--primary);
        background: #fff;
        font-size: 1.6rem;
        line-height: 1.9rem;
        border-radius: 4px;
        border: 1.5px solid var(--primary);
        min-width: 12.5rem;
        transition: 0.3s ease-out;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 5rem;
        cursor: pointer;

        &:hover {
          color: #fff;
          background: var(--primary);
        }
      }
    }
    .button {
      height: 5rem;
    }
  }
}
</style>
